import React, { useState, useRef, useEffect } from 'react';
import { getIconComponent } from '../utils/iconHelper';
import { MdSearch, MdExpandMore, MdClose } from 'react-icons/md';
import './CategorySelect.css';

function CategorySelect({ categories, selectedId, onSelect, type, label = 'Categoria', hasError = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  // Filtrar categorias por tipo e termo de busca
  const filteredCategories = categories
    .filter(cat => cat.type === type)
    .filter(cat => 
      cat.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter(cat => cat.is_active !== false);

  const selectedCategory = categories.find(cat => cat.id === selectedId);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Focar no input de busca ao abrir
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const handleSelect = (category) => {
    onSelect(category.id);
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onSelect('');
    setSearchTerm('');
  };

  return (
    <div className="category-select" ref={dropdownRef}>
      <label className="category-select-label">{label}</label>
      
      <div 
        className={`category-select-trigger ${isOpen ? 'open' : ''} ${!selectedCategory ? 'empty' : ''} ${hasError ? 'error' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedCategory ? (
          <div className="selected-category">
            <div 
              className="category-icon-small"
              style={{ backgroundColor: selectedCategory.color }}
            >
              {(() => {
                const IconComponent = getIconComponent(selectedCategory.icon);
                return <IconComponent size={20} color="white" />;
              })()}
            </div>
            <span className="category-name">{selectedCategory.name}</span>
            {selectedCategory && (
              <button
                type="button"
                className="clear-btn"
                onClick={handleClear}
                title="Limpar seleção"
              >
                <MdClose size={18} />
              </button>
            )}
          </div>
        ) : (
          <span className="placeholder">Selecione uma categoria</span>
        )}
        <MdExpandMore className={`expand-icon ${isOpen ? 'rotated' : ''}`} size={24} />
      </div>

      {isOpen && (
        <div className="category-select-dropdown">
          <div className="category-search">
            <MdSearch size={20} className="search-icon" />
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Buscar categoria..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          <div className="category-options">
            {filteredCategories.length === 0 ? (
              <div className="no-results">
                <p>Nenhuma categoria encontrada</p>
              </div>
            ) : (
              filteredCategories.map((category) => {
                const IconComponent = getIconComponent(category.icon);
                const isSelected = category.id === selectedId;

                return (
                  <div
                    key={category.id}
                    className={`category-option ${isSelected ? 'selected' : ''}`}
                    onClick={() => handleSelect(category)}
                  >
                    <div 
                      className="category-icon-small"
                      style={{ backgroundColor: category.color }}
                    >
                      <IconComponent size={20} color="white" />
                    </div>
                    <span className="category-name">{category.name}</span>
                    {isSelected && (
                      <span className="check-mark">✓</span>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default CategorySelect;
